// @flow
import React, { useState, useEffect } from 'react';

type Props = {
  value: string,
  description?: string,
};

export function Flipper(props: Props) {
  const [oldValue, setOldValue] = useState(props.value);
  const [latestValue, setLatestValue] = useState(props.value);
  const [transition, setTransition] = useState('Flipper-nothing');

  useEffect(
    () => {
      setOldValue(latestValue);
      setLatestValue(props.value);
      if (props.value !== latestValue) {
        setTransition('Flipper-leave');
      }
    },
    [props.value],
  );

  return (
    <span data-testid={props.value} className="relative">
      {!!props.description && (
        <span className="a11y" data-testid="srOnly">
          {props.description}
        </span>
      )}
      <span
        key={transition}
        className={`text-center ${transition}`}
        data-testid="Flipper-value"
        onAnimationEnd={event => {
          switch (event.animationName) {
            case 'Flipper-leave':
              setTransition('Flipper-enter');
              break;
            case 'Flipper-enter':
              setTransition('Flipper-enter');
              break;
            default:
              break;
          }
        }}
      >
        {transition === 'Flipper-leave' ? oldValue : latestValue}
      </span>
    </span>
  );
}
